var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: { "mask-closable": false, width: "450", closable: false },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c("div", { staticClass: "modalhead" }, [
        _c("div", {}, [_vm._v("流水详情")]),
        _c("div", { staticClass: "secondTitle" }, [
          _vm._v("流水号：" + _vm._s(_vm.params.id)),
        ]),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("业务类型")]),
          _c("div", { staticClass: "fr" }, [
            _vm._v(_vm._s(this.$filters.getFondTypeName(_vm.params.fundType))),
          ]),
        ]),
        this.$filters.getFondTypeName(_vm.params.fundType) == "退款" ||
        this.$filters.getFondTypeName(_vm.params.fundType) == "保证金退款返还"
          ? _c("div", { staticClass: "line" }, [
              _c("div", { staticClass: "fl" }, [_vm._v("退款时间")]),
              _c("div", { staticClass: "fr" }, [
                _vm._v(
                  _vm._s(
                    this.$filters.timestampToDatetime(_vm.params.operateTime)
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "line" }, [
          _c("div", { staticClass: "fl" }, [_vm._v("交易流水号")]),
          _c("div", { staticClass: "fr" }, [
            _vm._v(_vm._s(_vm.params.transactionId)),
          ]),
        ]),
        this.$filters.getFondTypeName(_vm.params.fundType) == "退款" ||
        this.$filters.getFondTypeName(_vm.params.fundType) == "保证金退款返还"
          ? _c("div", { staticClass: "line" }, [
              _c("div", { staticClass: "fl" }, [_vm._v("退款金额")]),
              _c("div", { staticClass: "fr" }, [
                _vm._v(
                  _vm._s(_vm.params.currency) + " " + _vm._s(_vm.params.amount)
                ),
              ]),
            ])
          : _vm._e(),
        _vm.params.fundType == "INBOUND"
          ? _c("div", { staticClass: "line" }, [
              _c("div", { staticClass: "fl" }, [_vm._v("入账金额")]),
              _c("div", { staticClass: "fr color-999" }, [
                _vm._v(
                  _vm._s(_vm.params.currency) + " " + _vm._s(_vm.params.amount)
                ),
              ]),
            ])
          : _vm._e(),
        _vm.params.diffentTradeCurrency
          ? _c("div", { staticClass: "line" }, [
              _c("div", { staticClass: "fl" }, [
                _vm._v(
                  "我们会以（原币种）给用户进行退款，以上金额数据为参考数据，实际退款金额以退款完成状态为准。"
                ),
              ]),
            ])
          : _vm._e(),
        _vm.params.fundType == "INBOUND"
          ? _c("div", { staticClass: "line" }, [
              _c("div", { staticClass: "fl" }, [_vm._v("入账时间")]),
              _c("div", { staticClass: "fr" }, [
                _vm._v(
                  _vm._s(
                    this.$filters.timestampToDatetime(_vm.params.operateTime)
                  )
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "textright", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              staticClass: "modal-btn",
              attrs: { type: "primary", size: "spec" },
              on: { click: _vm.sure },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }